export const colors = {

    bg1: "#182B49",
    bg2: "#F6F9FF",
    bg3: "#2B3B6A",
    gr_bg: "linear-gradient(90deg, #4a2559 0%, #182B49 100%)",
    gr_bg2: "linear-gradient(90deg, #84479c 0%, #1d2f4f 100%)",
    copy_bg: "#122340",
    blue: "#2c97ea",
    green: "#84479c",
    green2: "#122340",
    red: "#ff6f6f",
    purple: "#84479c",
    yellow: "#fbab19",
    black1: "#182B49",
    black2: "#444444",
    text1: "#555555",
    text2: "#666666",
    text3: "#969696",
    text4: "#aaaaaa",
    text5: "#cccccc",
    border1: "#eeeeee",
    border2: "#3e3e3e",
    border3: "#dddddd",
    footer1: "#1a1b25",
    footer2: "#16171f",
    ftext: "#8D8E92",

}

export const fonts = {

    roboto: "'Roboto', sans-serif",
    poppins: "'Poppins', sans-serif",

}